import api from './api';

export const teacherPaymentService = {
  getAll: (params?: any) => api.get('/teacher-payments', { params }),
  getById: (id: number) => api.get(`/teacher-payments/${id}`),
  create: (data: any) => api.post('/teacher-payments', data),
  update: (id: number, data: any) => api.put(`/teacher-payments/${id}`, data),
  delete: (id: number) => api.delete(`/teacher-payments/${id}`),
  markAsPaid: (id: number) => api.post(`/teacher-payments/${id}/mark-paid`),
  bulkCreate: (data: any) => api.post('/teacher-payments/bulk-create', data),
  getMonthlySummary: (month: string, year: number) => 
    api.get(`/teacher-payments/summary/${month}/${year}`),
  getYearlySummary: (year: number) => api.get(`/teacher-payments/yearly-summary/${year}`),
  // Calcular salario
  calculateSalary: (teacherId: number, data: any) => 
    api.post(`/teachers/${teacherId}/calculate-salary`, data),
  sendReceiptByEmail: (id: number) => api.post(`/teacher-payments/${id}/send-email`),
    
  generatePDF: (id: number) => api.get(`/teacher-payments/${id}/pdf`, {
      responseType: 'blob' // Importante para recibir el archivo
  }),
    
  // Método adicional para descargar PDF directamente
  downloadPDF: async (id: number, fileName?: string) => {
      const response = await api.get(`/teacher-payments/${id}/pdf`, {
          responseType: 'blob'
      });
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || `recibo-pago-${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return response;
  }
};